import React, { createContext, useContext, useMemo } from 'react';
import styles from './TableRow.module.scss';
import cx from 'classnames';
import { Text } from '@chaser/components';

export const MappingTableRowContext = createContext(null);

const MappingTableRow = ({ field, isNested: isNestedProp, children }) => {
  const description = useMemo(() => {
    if (!field.description) return null;

    const { type, content } = field.description;

    if (type === 'TEXT' && content) {
      return <div className={styles.text}>{content}</div>;
    }

    if (type === 'HTML' && content) {
      return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }

    return null;
  }, [field.description]);

  const context = useContext(MappingTableRowContext);
  const isNested = isNestedProp || context?.isNested;

  return (
    <tr className={cx(styles.tableRow, { [styles.nested]: isNested })}>
      <td className={styles.tableRowCell}>
        <div className={styles.name}>
          <Text fontWeight="bold">{field.name || ''}</Text>
        </div>
      </td>

      <td className={styles.tableRowCell}>
        <Text color={field.required ? 'Red' : undefined}>
          {field.required ? 'Required' : 'Optional'}
        </Text>
      </td>

      <td className={cx(styles.tableRowCell, styles.description)}>
        <Text fontSize="xxsmall">{description}</Text>
      </td>

      <td className={styles.tableRowCell}>{children || null}</td>
    </tr>
  );
};

export default MappingTableRow;
